// @ts-nocheck
import { useMutation, useQueryClient } from 'react-query';
import { transformResponse } from '@/utils';
import { useRequestQuery } from '../useQueryRequest';
import useApiRequest from '../useRequest';
import t from './types';

/**
 * Create a new currency.
 */
export function useCreateSalesPerson(props) {
  const queryClient = useQueryClient();
  const apiRequest = useApiRequest();

  return useMutation((values) => apiRequest.post('settings/salespeople', values), {
    onSuccess: () => {
      // Invalidate currencies.
      queryClient.invalidateQueries(t.SETTING_SALESPEOPLE);
    },
    ...props,
  });
}

/**
 * Edits the given currency code.
 */
export function useEditSalesPerson(props) {
  const queryClient = useQueryClient();
  const apiRequest = useApiRequest();

  return useMutation(
    ([currencyCode, values]) =>
      apiRequest.put(`settings/salespeople/${currencyCode}`, values),
    {
      onSuccess: () => {
        // Invalidate currencies.
        queryClient.invalidateQueries(t.SETTING_SALESPEOPLE);
      },
      ...props,
    },
  );
}

/**
 * Deletes the given currency.
 */
export function useDeleteSalesPerson(props) {
  const queryClient = useQueryClient();
  const apiRequest = useApiRequest();

  return useMutation(
    (id) => apiRequest.delete(`settings/salespeople/${id}`),
    {
      onSuccess: () => {
        // Invalidate currencies.
        queryClient.invalidateQueries(t.SETTING_SALESPEOPLE);
      },
      ...props,
    },
  );
}

export function useSalesPerson(id, props) {
  return useRequestQuery(
    [t.SETTING_SALESPERSON, id],
    { method: 'get', url: `settings/salespeople/${id}` },
    {
      enabled: !!id,
      select: (res) => transformResponse(res.data.salesperson),
      defaultData: null,
      ...props,
    },
  );
}

/**
 * Retrieve the currencies list.
 */
export function useSalespeople(props) {
  return useRequestQuery(
    [t.SETTING_SALESPEOPLE],
    { method: 'get', url: 'settings/salespeople/' },
    {
      select: (res) => res.data.salespeople,
      defaultData: [],
      ...props
    },
  );
}
